"use client";

import { c as _c } from "react/compiler-runtime";
import { DoseTable } from "@/app/[tenant]/(console)/scribe/playground/[id]/weight-loss/dose-table";
import CollapsibleSection from "@/components/ui/collapsible-section";
import type { PatientDetail } from "@/types/patient";
interface MedicationsSectionProps {
  patient: PatientDetail;
}
export default function MedicationsSection(t0) {
  const $ = _c(2);
  const {
    patient
  } = t0;
  let t1;
  if ($[0] !== patient) {
    t1 = <CollapsibleSection title="Medications" persistKey="medications" id="medications-section"><DoseTable patient={patient} showAddButton={true} autoCollapseOlder={true} title="Provider Administered" subtitle="Doses recorded by a provider. Showing provider name when available." /></CollapsibleSection>;
    $[0] = patient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}